<script>
import { mapActions } from 'vuex';
import i18n from "@/plugins/i18n";

export default {
    name: 'Vision, Mission & Values',

    props: {
        selectedCompanyId: {
            type: Number,
            required: true
        },

        type: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            info: null,
        }
    },

    watch: {
        info(newVal, oldVal) {
            if (newVal == null) newVal = '';
            if (oldVal == null) oldVal = '';

            if (newVal.length >= oldVal.length) {
                const el = window.document.getElementById('textArea');
                if (el) {
                    if (el.clientHeight < el.scrollHeight) {
                        el.style.height = `${10 + el.scrollHeight}px`;
                    }
                } else {
                    el.style.height = '100px';
                }
            }

            if (newVal.includes('  ')) {
                this.info = newVal.replace('  ', ' ');
            }
        }
    },

    mounted() {
        this._getVisionMissionValues();
    },

    methods: {
        ...mapActions('auditor', [
            'getVisionMissionValues',
        ]),

        _getVisionMissionValues() {
            this.getVisionMissionValues({type: this.type, body: { audited_company_id: this.selectedCompanyId }})
                .then(res => {
                    const data = res.data[`${this.type}`];

                    this.info = data != null && data != undefined ? data : '';
                })
                .finally(() => {
                    const el = window.document.getElementById('textArea');
                    if (el) {
                        if (el.clientHeight < el.scrollHeight) {
                            el.style.height = `${10 + el.scrollHeight}px`;
                        }
                    } else {
                        el.style.height = '100px';
                    }
                })
        },

        _updateCompany() {
            if (this.allDisabled) return;
            if (this.info.length < 250 || this.info.length > 5000) {
                this.$notify('error', i18n.t('companyProfile.field_not_in_range'), true);
                return;
            }

            const params = {
                company_id: this.selectedCompanyId,
                body: {
                    [`${this.type}`]: this.info
                }
            }

            this.updateCompany(params)
                .then(res => {
                    this.setFallbackValue(null);
                    this.$notify('success', res.data.messageName);
                })
                .catch(({ response }) => {
                    this.info = this.fallbackValue;
                    this.$notify('error', response.data.messageName);
                })
        },

        setFallbackValue(val) {
            this.fallbackValue = val;
        },
    }
}
</script>

<template>
    <div class="vmv-item">
        <textarea id="textArea" rows="4" v-model="info" 
            maxlength="5000" disabled
        ></textarea>
    </div>
</template>

<style lang='scss' scoped>
.vmv-item {
    width: 100%;
    height: 100%;
    padding-bottom: 2em;
}

textarea {
    min-height: 100% !important;
    width: 100%;
    padding: .5em;
    border-radius: .25em;
    border: 0 !important;
    outline-width: 0;

    background-color: whitesmoke;

    &:focus {
        outline-style: solid;
        outline-width: .125em;
        background-color: rgb(234, 234, 234);
    }
}
</style>